<template>
    <div class="edit-policy-container">
        <div class="banner">
            <div class="wrapper">
                <p class="breadcrumb">개인정보 처리방침</p>
                <div class="header-row">
                    <p class="title">개인정보 처리방침</p>
                    <button class="btn" @click=submit()>수정</button>
                </div>
            </div>
        </div>

        <div class="editor-wrapper">
            <div class="editor-page">
                <editor @update='updateContent' :message="content"></editor>
            </div>
        </div>
    </div>
</template>
<script>
import Editor from '@/views/notice/VueEditor.vue'
import * as policyeApi from '@/api/policy'
import { onMounted, reactive, toRef } from "vue";

export default {
    components: { Editor },
    setup() {
        onMounted(() => {
            get()
        })
        const state = reactive({
            content: null,
            createdAt: null,
            id: null
        })
        const content = toRef(state, 'content')
        const updateContent = (c) => {
            if (c) {
                state.content = c
            }
            else {
                console.err("updateContent err: ", c)
            }
        }
        const submit = () => {
            const request = {
                contents: state.content,
            }
            policyeApi.postPrivacyPolicy(request).then((res) => {
                console.debug("response:", res)
                if (res.status == 201)
                    alert("수정 완료")
            })
        }
        const get = () => {
            policyeApi.getPrivacyPolicy().then((res) => {
                let response = res.data.response
                state.id = response.id
                state.content = response.contents
                state.createdAt = response.createdAt
                console.debug("response:", state.id, state.content, state.createdAt)
            });
        }
        return { submit, get, state, updateContent, content }
    }
}
</script>
<style scoped>
.edit-policy-container {
    display: flex;
    flex-direction: column;
    width: 100%;
}

/* Banner Header */
.banner {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 32px 80px;
    gap: 10px;
    width: 100%;
    height: 142px;
    background: #CFD8DC;
}

.wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    gap: 16px;
    width: 100%;
    height: 78px;
    align-self: stretch;
}

.breadcrumb {
    margin: 0;
    width: auto;
    height: 20px;
    font-family: 'Pretendard', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.3px;
    color: #37474F;
}

.header-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
    gap: 24px;
    width: 100%;
    height: 42px;
    align-self: stretch;
}

.title {
    margin: 0;
    flex-grow: 1;
    height: 38px;
    font-family: 'Pretendard', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 38px;
    letter-spacing: -0.3px;
    color: #37474F;
    border: none;
    background: transparent;
    outline: none;
}

.btn {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 26px;
    gap: 8px;
    width: 80px;
    height: 42px;
    background: #37474F;
    box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
    border-radius: 10px;
    border: none;
    cursor: pointer;
    flex-shrink: 0;
    color: #ECEFF1;
}

/* Editor Section */
.editor-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 60px;
    width: 100%;
    height: 713px;
    margin-top: 40px;
}

.editor-page {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    width: 100%;
    height: 100%;
}

.editor-page :deep(.ql-toolbar) {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 24px;
    gap: 4px;
    width: 100%;
    height: 48px;
    background: #607D8B;
    border-radius: 20px 20px 0px 0px;
    border: none;
}

.editor-page :deep(.ql-container) {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px 24px;
    width: 100%;
    height: 665px;
    background: #CFD8DC;
    border-radius: 0px 0px 20px 20px;
    border: none;
}

.editor-page :deep(.ql-editor) {
    width: 100%;
    height: 100%;
    font-family: 'Pretendard', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.3px;
    color: #90A4AE;
    flex-grow: 1;
}
</style>